module.exports = __webpack_public_path__ + "media/application/images/icons/test-pic-f79f8d9697291b189afa30b692809c51.svg";